import constant from '@/assets/js/filter'
import cookie from "../assets/js/cookie";
export default {
  state: {
    username: '', // 用户名
    avatar: '',  // 头像
    skin: null, // 皮肤
    token: null,
    secret: null,
    pprAuth: null,
    role: null,
    route: null, // 路由
    isNewEdition:cookie.getCookie("isNewEdition")==='false'?false:true,
    // [切换用户所需字段](New 区别管理员与用户冲突)
    avatarNew: '', // 用户头像[重命名][缺]
    qnameNew: '', // 用户昵称
    usrNew: '', // 账号名称
    enableNew: '', // 是否禁用
    activeNew: '', // 活跃度
    roleNew: '', // 用户角色[重命名]
    mobileNew: '', // 电话
    emailNew: '', // 邮箱
    groupNew: '', // 分组
    createTimeNew: '', // 创建时间
    lastLoginTsNew: '', // 最后登录时间
    sourceNew: '', // 用于判断是否储能用户
    uidNew: '', //
    uidExtra: '', // (辅助字段用户用于控制某些操作按钮显隐)
    addCollectorPermissions: '', // (经销商role=2是否可以新增采集器标识)
    dealerVcode: '', // 经销商所属厂家编码
    rolePermissionId: '',//厂家创建经销商账号选择的角色权限ID
    riyueyuanUserTypeRid: '',//日月元新增用户类型标识
    groupIdClick: '', // [获取分组ID]
    groupNameClick: '', // [获取分组名称]
    accountTotal: '', // [保存账户总数]
    collectorsNew: '', // [保存数采器总数]
    devicesNew: '', // [保存设备总数]
    groupIsShow:0,
    chartStatus:null,//图表状态
    riyueyuanPermissionMark:false,//日月元账号状态判断-权限
    riyueyuanRid:'',//保存日月元账号新增用户类型标识
    producercode:'',//厂家账号编码
    uid:'',//用户ID
    vcodes:[],//业主厂家编码集合

    method:'getDEVMicroservices',
    isMicroService: false,
    code:'err',
    resData:'dat'
  },
  getters: {
    //获取账号图表状态
    getChartStatus: state => {
      return {
        chartStatus: state.chartStatus,
      }
    },
    //获取日月元账号状态判断
    getRiyueyuanPermissionMark: state => {
      return {
        riyueyuanPermissionMark: state.riyueyuanPermissionMark,
      }
    },
    //账号分组显隐
    getGroupIsShow: state => {
      return {
        groupIsShow: state.groupIsShow,
      }
    },
    // 获取皮肤
    getSkin: state => {
      let storage = localStorage.getItem('skin'), skin
      if (state.skin) {
        skin = state.skin
      } else if (storage) {
        state.skin = skin = storage
      } else {
        skin = Object.keys(constant.skin)[0]
      }
      // 设置皮肤相应css变量
      let variable = constant.skin[skin].variable
      for (let key in variable) {
        let value = variable[key], root = document.querySelector(':root')
        root.style.setProperty(key, value)
      }
      return skin
    },
    // [获取账户信息]
    getAccountInfo: state => {
      return {
        // [切换用户所需字段]
        avatarNew: state.avatarNew, // 用户头像[重命名][缺]
        qnameNew: state.qnameNew, // 用户昵称
        usrNew: state.usrNew, // 账号名称
        enableNew: state.enableNew, // 是否禁用
        activeNew: state.activeNew, // 活跃度
        roleNew: state.roleNew, // 用户角色[重命名]
        // role: state.role, // 用户角色[重命名]
        mobileNew: state.mobileNew, // 电话
        emailNew: state.emailNew, // 邮箱
        groupNew: state.groupNew, // 分组
        createTimeNew: state.createTimeNew, // 创建时间
        lastLoginTsNew: state.lastLoginTsNew, // 最后登录时间
        sourceNew: state.sourceNew, // 用于判断是否储能用户
        uidNew: state.uidNew, // 
        collectorsNew: state.collectorsNew, // 数采器总数
        devicesNew: state.devicesNew, // 设备总数
        addCollectorPermissions: state.addCollectorPermissions, // 是否有新增数采器权限
        rolePermissionId: state.rolePermissionId, //厂家创建经销商账号选择的角色权限ID
        riyueyuanUserTypeRid: state.riyueyuanUserTypeRid, //日月元新增用户类型标识
      }
    },
    // [获取分组ID,名称]
    getGroupIdClick: state=> {
      return {
        groupIdClick: state.groupIdClick,
        groupNameClick: state.groupNameClick
      }
    },
    // [保存账户总数]
    getAccountTotal: state=> {
      return {
        accountTotal: state.accountTotal
      }
    },
  },
  mutations: {
    //厂家编码
    saveProducercode(state, producercode) {
      state.producercode = producercode
    },
    //业主设备厂家编码
    saveVcodes(state, vcodes) {
      state.vcodes = vcodes
    },
    // 保存鉴权信息
    saveAuth(state, { token, secret, role, pprAuth }) {
      state.token = token
      state.secret = secret
      state.role = role
      state.pprAuth = pprAuth
    },
    // 保存路由
    saveRoute(state, route) {
      state.route = route
    },
    // 保存图表状态
    saveChartStatus(state, chartStatus) {
      state.chartStatus = chartStatus
    },
    // 保存日月元账号标识-权限
    saveRiyueyuanPermissionMark(state, riyueyuanPermissionMark) {
      state.riyueyuanPermissionMark = riyueyuanPermissionMark
    },
    // 保存日月元账号新增用户类型标识
    saveRiyueyuanRid(state, riyueyuanRid) {
      state.riyueyuanRid = riyueyuanRid
    },
    // 保存用户信息
    saveUserInfo(state, {username, avatar, uidExtra,addCollectorPermissions,dealerVcode}) {
      if(username) state.username = username
      if(avatar) state.avatar = avatar
      if(uidExtra) state.uidExtra = uidExtra
      if(addCollectorPermissions) state.addCollectorPermissions = addCollectorPermissions
      if(dealerVcode) state.dealerVcode = dealerVcode
    },
    // [保存账户信息] {, roleNew,} {, role,}
    saveAccountInfo(state, {avatarNew, qnameNew, usrNew, enableNew, activeNew, roleNew, mobileNew, emailNew, groupNew, createTimeNew, lastLoginTsNew, sourceNew, uidNew, uidExtra,collectorsNew,devicesNew,addCollectorPermissions,rolePermissionId,riyueyuanUserTypeRid}) {
      // [切换用户所需字段]
      if(avatarNew !== undefined) state.avatarNew = avatarNew // 用户头像[缺]
      if(qnameNew !== undefined) state.qnameNew = qnameNew // 用户昵称
      if(usrNew !== undefined) state.usrNew = usrNew // 账号名称
      if(enableNew !== undefined) state.enableNew = enableNew // 是否禁用
      if(activeNew !== undefined) state.activeNew = activeNew // 活跃度
      if(roleNew !== undefined) state.roleNew = roleNew // 用户角色
      // if(role !== undefined) state.role = role // 用户角色
      if(mobileNew !== undefined) state.mobileNew = mobileNew // 电话
      if(emailNew !== undefined) state.emailNew = emailNew // 邮箱
      if(groupNew !== undefined) state.groupNew = groupNew // 分组
      if(createTimeNew !== undefined) state.createTimeNew = createTimeNew // 创建时间
      if(lastLoginTsNew !== undefined) state.lastLoginTsNew = lastLoginTsNew // 最后登录时间
      if(sourceNew !== undefined) state.sourceNew = sourceNew // 用于判断是否储能用户
      if(uidNew !== undefined) state.uidNew = uidNew // 
      if(uidExtra !== undefined) state.uidExtra = uidExtra // 辅助字段用户用于控制某些操作按钮显隐
      if(devicesNew !== undefined) state.devicesNew = devicesNew // 辅助字段用户用于控制某些操作按钮显隐
      if(collectorsNew !== undefined) state.collectorsNew = collectorsNew // 辅助字段用户用于控制某些操作按钮显隐
      if(addCollectorPermissions !== undefined) state.addCollectorPermissions = addCollectorPermissions // 是否有新增数采器权限
      if(rolePermissionId !== undefined) state.rolePermissionId = rolePermissionId // 厂家创建经销商账号选择的角色权限ID
      if(riyueyuanUserTypeRid !== undefined) state.riyueyuanUserTypeRid = riyueyuanUserTypeRid // 日月元新增用户类型标识
    },
    // [保存分组ID]
    saveGroupIdClick(state, {groupIdClick,groupNameClick}) {
      if(groupIdClick !== undefined) state.groupIdClick = groupIdClick
      state.groupNameClick = groupNameClick
    },
    // [保存账户总数]
    saveAccountTotal(state, {accountTotal}) {
      if(accountTotal !== undefined) state.accountTotal = accountTotal
    },
    //保存版本
    saveEditionType(state, { isNewEdition }) {
      state.isNewEdition = isNewEdition
    },
    // 保存皮肤
    saveSkin(state, skin) {
      state.skin = skin
      localStorage.setItem('skin', skin)
    },
    // 登出
    logout(state) {
      // sessionStorage.clear(); // 或单独 removeItem('secret')、removeItem('token')、removeItem('role')
      // sessionStorage.removeItem('hasAutoLogin'); // 清除自动登录标记
      // cookie.delCookie('token', 'secret', 'role','userInfo')
      let userInfo = cookie.getCookie('userInfo');
      if (userInfo) {
        try {
          userInfo = JSON.parse(userInfo);
          delete userInfo.isRem; // 删除 isRem 字段
          cookie.setCookie('userInfo', JSON.stringify(userInfo), 7 * 24 * 60 * 60); // 重新写回，保留一周
        } catch (e) {
          // 解析失败则直接删除整个 cookie
          cookie.delCookie('userInfo');
        }
      }
      cookie.delCookie('token', 'secret', 'role','pprAuth')
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('secret')
      sessionStorage.removeItem('role')
      sessionStorage.removeItem('isLogin')
      sessionStorage.removeItem('moduleArr')
      sessionStorage.removeItem('firstPageArr')
      sessionStorage.removeItem('secPageArr')
      sessionStorage.removeItem('buttonArr')
      sessionStorage.removeItem('disPermissionsLogo')
      sessionStorage.removeItem('pprAuth')
      state.token = null
      state.secret = null
      state.pprAuth = null
      state.role = null
      state.route = null
      state.username = null
      state.avatar = null
    },
    saveGroupIsShow(state, groupIsShow) {
      if (groupIsShow !== undefined) state.groupIsShow = groupIsShow
    },
    saveIsMicroService(state, isMicroService) {
      state.isMicroService = Boolean(isMicroService)
      state.method = Boolean(isMicroService) ? 'getDEVMicroservices' : 'get';
      state.code  = Boolean(isMicroService)?'code':'err';
      state.resData = Boolean(isMicroService)?'data':'dat';
    },
  },
  actions: {
  }
}